import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { ReactKit } from '@team/react';
import { Tappable } from '../../services/tappable';
import { Subheadline } from '../../typography/subheadline';
import { Text } from '../../typography/text';
import { Caption } from '../../typography/caption';
import { Props } from './types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  {
    before,
    subhead,
    children,
    subtitle,
    description,
    after,
    multiline = false,
    baseClassName,
    ...props
  },
  forwardedRef
) {
  return (
    <Tappable
      {...props}
      baseClassName={clsx(css.root, baseClassName, {
        [css.multiline]: multiline,
      })}
      ref={forwardedRef}
    >
      {ReactKit.hasNode(before) && <div className={css.before}>{before}</div>}

      <div className={css.content}>
        <div className={css.contentStart}>
          {ReactKit.hasNode(subhead) && (
            <Subheadline
              className={clsx(css.subhead, css.text)}
              level={2}
              weight={3}
            >
              {subhead}
            </Subheadline>
          )}

          <div className={css.contentMain}>
            <Text className={clsx(css.title, css.text)} weight={3}>
              {children}
            </Text>
          </div>

          {ReactKit.hasNode(subtitle) && (
            <Subheadline
              className={clsx(css.subtitle, css.text)}
              level={2}
              weight={3}
            >
              {subtitle}
            </Subheadline>
          )}

          {ReactKit.hasNode(description) && (
            <Caption
              className={clsx(css.description, css.text)}
              level={1}
              weight={3}
            >
              {description}
            </Caption>
          )}
        </div>

        {ReactKit.hasNode(after) && (
          <div className={css.contentEnd}>{after}</div>
        )}
      </div>
    </Tappable>
  );
});
